// import { EcommerceOrder } from "../../ECommerceApi";

/**
 * The application statuses.
 */
const applicationStatuses = [
  {
    id: "1",
    name: "Under verification",
    value: "under_verification",
    color: "bg-purple-700 text-white",
  },
  {
    id: "2",
    name: "Granted",
    value: "granted",
    color: "bg-green-700 text-white",
  },
  {
    id: "3",
    name: "In progress",
    value: "in_progress",
    color: "bg-blue-500 text-white",
  },
  {
    id: "4",
    name: "Rejected",
    value: "rejected",
    color: "bg-red-700 text-white",
  },
  {
    id: "5",
    name: "Active",
    value: "Active",
    color: "bg-green-700 text-white",
  },
  {
    id: "6",
    name: "Inactive",
    value: "Inactive",
    color: "bg-red-700 text-white",
  },
  {
    id: "7",
    name: "Drafted",
    value: "Drafted",
    color: "bg-orange-500 text-white",
  },
  {
    id: "8",
    name: "Verified",
    value: "Verified",
    color: "bg-green-700 text-white",
  },
  {
    id: "9",
    name: "Not Verified",
    value: "Not Verified",
    color: "bg-orange-500 text-white",
  },
  {
    id: "10",
    name: "Submitted",
    value: "Submitted",
    color: "bg-green-700 text-white",
  },
  {
    id: "11",
    name: "Draft",
    value: "Draft",
    color: "bg-orange-500 text-white",
  },
];

export default applicationStatuses;
